import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    api.get(`/blog/${slug}`)
      .then(({ data }) => setPost(data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#F9F8F6] grain" data-testid="blog-post-page">
      <Navbar />
      <article className="pt-40 pb-20">
        <div className="container-prose max-w-3xl">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-[#5C6670] hover:text-[#8A9A86] mb-10" data-testid="back-to-blog">
            <ArrowLeft size={16} /> Wróć do wszystkich artykułów
          </Link>

          {loading && <p className="text-[#5C6670]">Ładowanie…</p>}
          {error && <p className="text-[#5C6670]">Artykuł nie został znaleziony.</p>}

          {post && (
            <>
              <p className="text-overline mb-6">{post.category}</p>
              <h1 className="font-display text-4xl md:text-6xl text-[#2B2B2B] leading-[1.05] mb-10">
                {post.title}
              </h1>
              {post.cover_image && (
                <div className="aspect-[16/9] rounded-2xl overflow-hidden mb-12">
                  <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
                </div>
              )}
              <div className="prose-content text-[#2B2B2B] text-lg leading-[1.8] font-light space-y-6 whitespace-pre-wrap">
                {post.content}
              </div>
            </>
          )}
        </div>
      </article>
      <Footer />
    </div>
  );
}
